<template>
  <div>
    <va-modal
      class="evollu-form"
      :value="showModal"
      id="createOrUpdateScanPacksModal"
      ref="createOrUpdateScanPacksModal"
      size="large"
      :showOkay="true"
      :okText="this.$t('agenda.availability.save')"
      :cancelText="$t('leads.back')"
      @cancel="$emit('cancel')"
      @ok="handleSubmit"
      :ok-disabled="!canSubmit"
      :noOutsideDismiss="false">

      <div slot="header" class="d-flex justify--space-between">
        <span>
          <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ this.selectedPack ? this.$t('biosigns.packs.updatePack', {name: selectedPack && selectedPack.name ? selectedPack.name : "N/A"}) : this.$t('biosigns.packs.createPack')}}</b></span>
        </span>
      </div>

      <div class="row mt-4">
        <div class="col-12 col-md-6">
          <div>
            <label class="form-label">{{$t('iframe.table_headings.client')}}:</label>
            <multiselect
              v-model="selectedClient"
              :options="clientOptions"
              track-by="id"
              label="name"
              :custom-label="formatedEntityLabel"
              select-label=""
              selected-label=""
              deselect-label=""
              :placeholder="$t('iframe.table_headings.client')"
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :disabled="clientOptions.length <= 1 || clientDropdownDisabled">
              <template slot="clear">
                <span class="multiselect__clear" v-if="selectedClient"
                      @mousedown.prevent.stop="selectedClient = null"></span>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div>
            <label class="form-label">Hash:</label>
            <multiselect
              v-model="selectedHash"
              :options="filteredFlows"
              track-by="id"
              label="hash"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="Hash"
              :allow-empty="true"
              :multiple="false"
              :searchable="true"
              :disabled="selectedClient === null || hashDropdownDisabled">
              <template slot="clear">
                <span class="multiselect__clear" v-if="selectedHash"
                      @mousedown.prevent.stop="selectedHash = null"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>

      <form class="evollu-form">
        <div class="row col-12 p-0">

          <div class="col-6 col-md-6 mb-4">
            <va-input
              id="name"
              type="text"
              v-model="form.name"
              :label="$t('accounts.name')"
              :placeholder="$t('accounts.name')"
            />
          </div>

          <div class="col-6 col-md-6 mb-2">
            <div>
              <label class="form-label">{{ $t('biosigns.packs.type.title') }}</label>
              <multiselect
                v-model="form.type"
                :options="scanPackTypes"
                track-by="id"
                :custom-label="elem => $t(`biosigns.packs.type.${elem.slug}`)"
                select-label=""
                selected-label=""
                deselect-label=""
                :placeholder="$t('biosigns.packs.type.title')"
                :allow-empty="false"
                :multiple="false"
                :searchable="true"
                :disabled="typeDropdownDisabled">
              </multiselect>
            </div>
          </div>

          <div class="col-6 col-md-6 mb-2">
            <div class="form-group form-group-agenda" :class="{'has-error': startError !== null}">
              <div class="input-group">
                <va-date-picker
                  class="w-100"
                  v-model="form.start"
                  :disabled="startPickerDisabled"
                  :placeholder="$t('activities_agenda.table.start')"
                  :label="$t('activities_agenda.table.start')"
                  :config="{
                          enableTime: true,
                          dateFormat: 'Y-m-d H:i',
                          time_24hr: true,
                          minDate: selectedPack ? null : moment().tz('Europe/Lisbon').startOf('day').toDate(),
                          maxDate: selectedPack ? moment(selectedPack.start).tz('Europe/Lisbon').add(12, 'months').toDate() : moment().tz('Europe/Lisbon').add(12, 'months').toDate()
                        }"/>
                <i class="bar"></i>
                <small v-show="startError !== null" class="help text-danger">
                  {{ startError }}
                </small>
              </div>
            </div>
          </div>

          <div class="col-6 col-md-6 mb-2">
            <div class="form-group form-group-agenda" :class="{'has-error': validUntilError !== null}">
              <div class="input-group">
                <va-date-picker
                  class="w-100"
                  v-model="form.validUntil"
                  :placeholder="$t('biosigns.accessCodes.formCreation.validUntil')"
                  :label="$t('biosigns.accessCodes.formCreation.validUntil')"
                  :config="{
                          enableTime: true,
                          dateFormat: 'Y-m-d H:i',
                          time_24hr: true,
                          minDate: selectedPack ? null : moment().tz('Europe/Lisbon').startOf('day').toDate(),
                          maxDate: selectedPack ? moment(selectedPack.start).tz('Europe/Lisbon').add(12, 'months').toDate() : moment().tz('Europe/Lisbon').add(12, 'months').toDate()
                        }"/>
                <i class="bar"></i>
                <small v-show="validUntilError !== null" class="help text-danger">
                  {{ validUntilError }}
                </small>
              </div>
            </div>
          </div>

          <div class="col-6 col-md-6 mb-2">
            <va-input
              id="quantity"
              type="number"
              v-model="form.quantity"
              :label="$t('biosigns.accessCodes.formCreation.quantity')"
              :placeholder="$t('biosigns.accessCodes.formCreation.quantity')"
              @input="quantityError = null"
            />

            <small v-show="quantityError !== null" class="help text-danger">
              {{ quantityError }}
            </small>
          </div>


        </div>


      </form>

    </va-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin.vue';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import { IframeService } from '@/api/IframeService';
import moment from 'moment-timezone';

export default {
  components: { Multiselect },
  mixins: [ClustersAndEntitiesMixin, MultiselectLabelFormatter],
  props: {
    clientOptions: {
      type: Array,
      required: true
    },
    selectedPack: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      showModal: false,
      isSubmitting: false,
      selectedClient: null,
      selectedHash: null,
      filteredFlows: [],
      flows: [],
      form: {
        name: null,
        quantity: null,
        start: moment().tz('Europe/Lisbon').format('YYYY-MM-DD HH:mm'),
        type: null,
        validUntil: null,
        testFlowHash: null,
      },
      quantityError: null,
      startError: null,
      validUntilError: null,
      testFlowHashError: null,
      typeDropdownDisabled: false,
      clientDropdownDisabled: false,
      hashDropdownDisabled: false,
      startPickerDisabled: false,
      scanPackTypes: [
        {
          id: 1,
          slug: 'monthly_included'
        },
        {
          id: 2,
          slug: 'top_up'
        }
      ],
    }
  },
  async mounted() {
    this.showModal = true
    this.flows = await IframeService.getAllFlowsUnpaginated()

    this.typeDropdownDisabled = true

    if(!this.selectedPack) {
      this.form.type = this.scanPackTypes.find(type => type.id === 2)
    } else {
      this.clientDropdownDisabled = true
      this.hashDropdownDisabled = true
      this.startPickerDisabled = true

      this.form.type = this.scanPackTypes.find(type => type.slug === this.selectedPack.type)
      this.form.name = this.selectedPack.name
      this.selectedClient = this.clientOptions.find(client => this.selectedPack.testFlow.client_id === client.id)
      this.selectedHash = this.flows.find(flow => flow.hash === this.selectedPack.testFlow.hash)
      this.form.start = moment(this.selectedPack.start).tz('Europe/Lisbon').format('YYYY-MM-DD HH:mm')
      this.form.validUntil = moment(this.selectedPack.validUntil).tz('Europe/Lisbon').format('YYYY-MM-DD HH:mm')
      this.form.quantity = this.selectedPack.totalNrScans
      this.form.id = this.selectedPack.id
    }
  },
  methods: {
    handleSubmit: function () {
      const data = {...this.form}
      data.type = data.type.slug
      data.entity = this.selectedClient.id
      data.totalNrScans = data.quantity
      delete data.quantity
      IframeService.postScanPack(data).then(res => {
        this.isSubmitting = true
        this.showToast(this.$t('configurations.business.values_submited'), this.$store.state.successToastOptions)
        this.$emit('submitted', res.data)
        this.showModal = false
      }).catch(err => {
        this.showToast(this.$t('configurations.business.values_submited_error'), this.$store.state.errorToastOptions)
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  },
  computed: {
    canSubmit() {
      return this.form.quantity !== null &&
        this.form.quantity !== '' &&
        this.form.quantity > 0 &&
        this.form.testFlowHash !== null &&
        this.form.testFlowHash !== '' &&
        this.form.validUntil &&
        moment(this.form.validUntil).tz('Europe/Lisbon').isSameOrBefore(moment(this.form.start).tz('Europe/Lisbon').add(12, 'months')) &&
        moment(this.form.validUntil).tz('Europe/Lisbon').isAfter(moment(this.form.start).tz('Europe/Lisbon')) &&
        this.form.start &&
        this.form.type &&
        this.form.name
    }
  },
  watch: {
    selectedClient: function (value) {
      if(value) {
        this.filteredFlows = this.flows.filter(flow => flow.clientId === value.id)
      } else {
        this.selectedHash = null
        this.filteredFlows = []
      }
    },
    selectedHash: function (value) {
      if(value) {
        this.form.testFlowHash = value.hash
      } else {
        this.form.testFlowHash = null
      }
    },
    'form.quantity': function (value) {
        if( !value || value < 1) {
          this.quantityError = this.$t('biosigns.accessCodes.formCreation.quantityError')
        } else {
          this.quantityError = null
          this.form.quantity = parseInt(value)
        }
      }
    }

}

</script>

<style scoped lang="scss">

</style>
